import 'slick-carousel'

const [w,d,l] = [window,document,location]

export default function HOME () {

  const init = () =>{

    $('.p-mainvisual__slider[data-plugin=slider]').each(function(){
      var $slider = $(this),
          $thumb_slider;
      $thumb_slider = $slider.clone(true).attr({class:'p-mainvisual__thumbs','data-plugin':'thumbs'});
      $slider.find('li>a').each(function(){
        var imgpath = $(this).children('img').attr('src');
        $(this).css({'background-image':'url("'+imgpath+'")'});
      });
      $thumb_slider.insertAfter($slider).wrap('<div class="p-mainvisual__thumbs-wrapper">');
      $thumb_slider.find('li>a>img').each(function(){
        $(this).unwrap('a');
      });
    });
    $('[data-plugin="slider"]').slick({
      fade: true,
      cssEase: 'ease-in-out',
      asNavFor: '[data-plugin="thumbs"]',
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      responsive: [{
        breakpoint: 768,
        settings:{
          dots: true,
          arrows: true,
          nextArrow: '<button class="btn-link slick-next"><svg><use xlink:href="/assets/svg/sprite.symbol.svg#yajirushi_right"></use></svg></button>',
          prevArrow: '<button class="btn-link slick-prev"><svg><use xlink:href="/assets/svg/sprite.symbol.svg#yajirushi_left"></use></svg></button>',
        }
      }]
    })
    $('[data-plugin="thumbs"]').slick({
      slidesToShow: 4,
      // centerMode: true,
      dots: false,
      focusOnSelect: true,
      variableWidth: true,
      autoplay: true,
      asNavFor: '[data-plugin="slider"]',
      arrows: true,
      nextArrow: '<button class="btn-link slick-next"><svg><use xlink:href="/assets/svg/sprite.symbol.svg#yajirushi_right"></use></svg></button>',
      prevArrow: '<button class="btn-link slick-prev"><svg><use xlink:href="/assets/svg/sprite.symbol.svg#yajirushi_left"></use></svg></button>',
    })


  }

  // グローバルメニューをスクロール量で表示する
  $.scrollspy({
    trigger: (w.innerHeight * 0.2),
    onBefore(/* pos */) {
      $('.p-header').addClass('is-firstview');
    },
    onAfter() {
      $('.p-header').removeClass('is-firstview');
    }
  })

  w.addEventListener('DOMContentLoaded',init)

}